/* eslint-disable camelcase */
import React, { Component } from 'react';
import LazyLoad from 'react-lazy-load';
import AdBlockDetect from 'react-ad-block-detect';
import { Button, Popup } from 'semantic-ui-react';
import './AdInfo.css';

class AdInfo extends Component {
  renderLink = (link, key) => {
    return (
      <div key={key}>
        <strong>{link}</strong>
      </div>
    );
  };

  renderDestinationUrls = (urls) => {
    return (
      <div>
        Destination URL(s):
        {urls.length > 0
          ? urls.map((link, key) => this.renderLink(link, key))
          : null}
      </div>
    );
  };

  renderUrlTags = (url_tags) => {
    const fontColor =
      url_tags !== '' && url_tags !== undefined ? 'black' : 'red';
    return (
      <div
        style={{
          color: fontColor
        }}
      >
        UTM: <strong>{url_tags}</strong>
      </div>
    );
  };

  renderDesktopAd = (preview) => {
    return (
      <div>
        <h4>Desktop Ad Preview</h4>
        <AdBlockDetect>
          <div className='Ad-Blocker-Message'>
            Please disable your ad blocker, and refresh this tab
          </div>
        </AdBlockDetect>
        <div className='filler' />
        <div
          style={{
            maxWidth: 720
          }}
        >
          <LazyLoad height={600} offsetVertical={1500}>
            <span
              dangerouslySetInnerHTML={{
                __html: preview.desktop_iframe_url
              }}
            />
          </LazyLoad>
        </div>
      </div>
    );
  };
  renderMobileAd = (preview) => {
    return (
      <div>
        <h4>Mobile Ad Preview</h4>
        <AdBlockDetect>
          <div className='Ad-Blocker-Message'>
            Please disable your ad blocker, and refresh this tab
          </div>
        </AdBlockDetect>
        <div className='filler' />
        <div
          style={{
            maxWidth: 320
          }}
        >
          <LazyLoad height={620} offsetVertical={900}>
            <span
              dangerouslySetInnerHTML={{
                __html: preview.mobile_iframe_url
              }}
            />
          </LazyLoad>
        </div>
      </div>
    );
  };

  renderCanvasName = (obj) => {
    return obj.name ? (
      <div>
        Canvas Name: <strong>{obj.name}</strong>
      </div>
    ) : null;
  };

  render() {
    const isCollection = this.props.ad.ad_name.indexOf('Collection') !== -1;
    const isCanvas = this.props.ad.ad_name.indexOf('Canvas') !== -1;
    console.log(this.props.ad.targetingSentenceLines);
    return (
      <div className='ad-container'>
        <div className='ad-header'>
          <div>
            {' '}
            Name: <strong>{this.props.ad.ad_name}</strong>
          </div>
          <div>
            {' '}
            Start Date: <strong>{this.props.ad.start_time}</strong>
          </div>
          <div>
            {' '}
            End Date: <strong>{this.props.ad.end_time}</strong>
          </div>
          {this.renderDestinationUrls(this.props.ad.destination_url)}
          {this.renderUrlTags(this.props.ad.url_tags)}
          {this.renderCanvasName(this.props.ad.canvas_name)}
          <div>
            {this.props.ad.ad_status === 'ACTIVE' ? (
              <i className='circle icon green' />
            ) : (
              <i className='circle icon black' />
            )}
            {this.props.ad.ad_status === 'ACTIVE' ? 'Active' : 'Inactive'}
          </div>
        </div>
        {this.props.ad.targetingSentenceLines ? (
          <Popup
            wide='very'
            trigger={
              <Button size='medium' color='red'>
                Target
              </Button>
            }
            content={this.props.ad.targetingSentenceLines.targetingsentencelines.targetingsentencelines.map(
              (target) => {
                return (
                  <p>
                    {target.content} {target.children[0]}
                  </p>
                );
              }
            )}
          />
        ) : null}
        {isCollection || isCanvas
          ? this.renderMobileAd(this.props.ad)
          : this.renderDesktopAd(this.props.ad)}
      </div>
    );
  }
}

export default AdInfo;



// WEBPACK FOOTER //
// ./src/screens/AdComparer/AdInfo.js